{
  "site": "Site navigation",
  "footerNav": "Footer navigation",
  "home": "Home",
  "overview": "My Overview",
  "about": "About",
  "howto": "Getting Started",
  "helpCenter": "Help Center",
  "guides": "Guides",
  "architecture": "Architecture",
  "trust": "Trust Center",
  "privacy": "Privacy",
  "terms": "Terms",
  "legalNav": "Legal navigation",
  "events": "Events",
  "competitions": "Explore competitions",
  "myCompetitions": "My Competitions",
  "applyToHost": "Apply to host",
  "competition": "Competition",
  "selectCompetition": "Select competition",
  "currentCompetition": "Current: {{name}}",
  "role": "View as",
  "currentRole": "Current role: {{role}}",
  "switchWorkspace": "Open as {{role}}",
  "roleSwitchAnnouncement": "Switched to the {{role}} workspace",
  "views": {
    "admin": "Organizer",
    "judge": "Judge",
    "student": "Participant",
    "observer": "Observer"
  },
  "language": "Language",
  "languages": { "zhTW": "繁體中文", "en": "English" },
  "menu": "Menu",
  "openMenu": "Open menu",
  "primary": "Primary navigation",
  "utility": "Utility navigation",
  "groups": {
    "explore": "Explore",
    "primary": "Main",
    "help": "Help",
    "preferences": "Preferences"
  },
  "theme": { "switchToLight": "Switch to light mode", "switchToDark": "Switch to dark mode" },
  "manualRoleNav": "Manual role",
  "manuals": {
    "student": "Participant",
    "judge": "Judge",
    "organizer": "Organizer",
    "admin": "Platform Admin"
  },
  "manualToc": "On this page",
  "manualRelated": "Other role guides"
}
